import { render, staticRenderFns } from "./VDataTableFooter.vue?vue&type=template&id=1c4ccdec&scoped=true&lang=pug"
import script from "./VDataTableFooter.vue?vue&type=script&lang=ts"
export * from "./VDataTableFooter.vue?vue&type=script&lang=ts"
import style0 from "./VDataTableFooter.vue?vue&type=style&index=0&id=1c4ccdec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ccdec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VPagination,VSelect})
